/* eslint-disable no-throw-literal */
export default function validateHotelSearchResultsResponse(response = {}) {
	const { supplierErrors, apiErrors } = response;

	if (supplierErrors?.length || apiErrors?.length) {
		throw { response: { apiErrors, supplierErrors } };
	}

	return response;
}
